<template  lang="pug">
  .devices-wrapper
    h2 gerenciamento de dispositivos
    .filters
      .total
        span total de dispositivos: {{ totalDevices }}
        PSelect(
          v-model="mode"
          name="mode"
          labelItem="name"
          :allowEmpty="false"
          title="mostrar"
          @change="changeMode"
        )
      .buttons
        PButton(
          color="primary"
          size="md"
          @click="genReport"
        )
          | gerar relatório de dispositivos
        PButton(
          v-if="mode.selected.id === 'app-gestor' || mode.selected.id === 'pc'"
          color="success"
          size="md"
          @click="approveAllDevices"
          v-has-permission="{module: 'manage', action: 'post', hide: true}"
        )
          | aprovar todos os dispositivos
    .table
      SmartTable(
        name="devices-list"
        v-bind="table"
        v-model="tableData"
        :loadPageFunction="loadPageTable"
        @rowClick="onSelectedDevice"
        ref="table"
      )
        template(v-slot:default="slotProps")
          TableRow(v-bind="slotProps")

            template(v-slot:name="{ columnValue }")
              span.no-wrap(:title="columnValue") {{ columnValue }}
            template(v-slot:reason="{ columnValue }")
              span.no-wrap(:title="columnValue") {{ columnValue }}
            template(v-slot:active="{ columnValue, rowItem, index }")
              .active
                .icon.fs-19.icon-ptt-icons-aprovar.color-success(v-if="columnValue === true")
                .icon.fs-19.icon-ptt-icons-reprovar.color-danger(v-else)
            template(v-slot:appVersion="{ columnValue, rowItem, index }")
              | {{ columnValue ? columnValue : '-' }}

        template(v-slot:detailsBox="{item}")
          Details(
            :device="deviceInfoPerId[item.id]"
            :loading="loadingSelectedDeviceInfo"
            @updateTable="updateTableAndCloseDetailsBox"
          )
</template>

<script>
import Cookies from 'js-cookie'
import Details from './Details'
import _ from 'lodash'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'Devices',
  async created () {
    setAmplitudeEvent('lista gestao de dispositivos', {})
  },
  data () {
    return {
      mode: {
        loaded: [{id: 'pc', name: 'computador'}, {id: 'mobile', name: 'aplicativo'}, {id: 'app-gestor', name: 'aplicativo gestor'}],
        selected: {id: 'pc', name: 'computador'}
      },
      allColumns: [
        {column: 'versão', field: 'appVersion', width: '.2fr'},
        {column: 'status', field: 'active', width: '130px'},
        {column: 'motivo', field: 'reason', width: '1fr'},
        {column: this.$ws('employee'), field: 'name', width: '1fr'},
        {column: 'código do dispositivo', field: 'id', width: '.7fr'},
        {column: 'sincronizado', field: 'lastSynced', width: '.5fr'}
      ],
      table: {
        headerItems: [],
        config: {
          perPage: 10,
          startFocusedSearch: 'name',
          defaultSortField: 'active',
          defaultColumnSearch: 'name'
        }
      },
      devices: [],
      selectedDevice: {
        index: null,
        item: null
      },
      loadingSelectedDeviceInfo: false,
      loadingDeviceInfo: false,
      deviceInfoPerId: {},
      totalDevices: 0,
      dispositivos: []
    }
  },
  computed: {
    tableData: {
      get () {
        return {
          loading: this.loadingDeviceInfo,
          loaded: this.devices
        }
      },
      set ({selected}) {
        this.selectedDevice = selected
      }
    }
  },
  methods: {
    async loadPageTable ({perPage, page, orderBy, search, reverse}) {
      this.loadingDeviceInfo = true
      this.deviceInfoPerId = {}

      const mode = this.mode.selected.id
      const pcFields = [
        'id', 'id_copy', 'kind',
        'name', 'reason',
        'active'
      ]
      const mobileFields = [
        'id', 'id_copy', 'name',
        'last_synced', 'app_version'
      ]

      if (mode === 'pc') {
        this.table.headerItems = this.allColumns
          .filter(c => pcFields.includes(_.snakeCase(c.field)))
      } else if (mode === 'app-gestor') {
        this.table.headerItems = this.allColumns
          .filter(c => pcFields.includes(_.snakeCase(c.field)))
      } else {
        this.table.headerItems = this.allColumns
          .filter(c => mobileFields.includes(_.snakeCase(c.field)))
      }

      let result
      try {
        result = await this.$API.deviceManage.get({
          page: page,
          type: this.mode.selected.id,
          order_by: orderBy,
          search: search,
          fields: JSON.stringify(mode === 'pc' || mode === 'app-gestor' ? pcFields : mobileFields),
          per_page: perPage,
          reverse: reverse
        })
        if (result.status === 204) {
          result = {
            body: {
              success: [],
              total: 0,
              totalPages: 0
            }
          }
        }
      } catch (e) {
        console.warn(e)
      }

      this.loadingDeviceInfo = false

      this.totalDevices = result.body.total

      const dispositivos = obterDispositivosDaRequisicaoPeloModoSelecionado(result.body.success)

      // fazendo uma cópia do objeto congelado pelo loadPages da SmartTable
      this.dispositivos = dispositivos.map((item) =>
        Object.assign({}, item)
      )
      const totalDispositivosPorModo = dispositivos.length

      return {
        items: dispositivos,
        totalItems: totalDispositivosPorModo,
        totalPages: result.body.totalPages
      }

      function obterDispositivosDaRequisicaoPeloModoSelecionado (dispositivosDaRequisicao = []) {
        const dispositivos = [...dispositivosDaRequisicao]

        const filtrosDeDispositivosPorModo = {
          'mobile': () => dispositivos,
          'app-gestor': () => dispositivos.filter(dispositivo => dispositivo.kind === 'app-gestor'),
          'pc': () => dispositivos.filter(dispositivo => dispositivo.kind !== 'app-gestor')
        }

        const filtrarDispositivosPeloModoSelecionado = filtrosDeDispositivosPorModo[mode]
        const listaDeDispositivosFiltradosPeloModoSelecionado = filtrarDispositivosPeloModoSelecionado()

        return listaDeDispositivosFiltradosPeloModoSelecionado
      }
    },
    async genReport () {
      try {
        const result = await this.$API.generateDeviceReport.save({}, {
          headers: {
            'Authorization': Cookies.get('Authorization')
          }
        })
        if (!result.ok) {
          console.warn(result)
          throw Error('erro no request')
        }

        this.$swal({
          type: 'success',
          text: 'O relatório está sendo gerado!'
        })
      } catch (e) {
        console.warn(e)
        this.$swal({
          type: 'error',
          text: 'Um erro impediu o relatório de ser iniciado. Tente novamente mais tarde'
        })
      }
    },
    async approveAllDevices () {
      const tipoDeDispositivo = this.mode.selected.id === 'pc' ? 'all' : 'app-gestor'
      const dispositivos = this.dispositivos
      const multiplosDispositivos = dispositivos.filter(dispositivo => dispositivo.active !== true).map(dispositivo => dispositivo.id)
      try {
        const result = await this.$API.approveDevices.save({
          kind: tipoDeDispositivo,
          multiplefingerprint: multiplosDispositivos
        })

        if ('success' in result.body) {
          this.$modalDeSucesso(result.body.success)
        } else if ('info' in result.body) {
          this.$modalDeInformacao(result.body.info)
        }
        this.$refs.table.resetPagesAndReload()
      } catch (e) {
        this.$modalDeErro(e.body?.error ? e.body.error : 'Ocorreu um erro ao tentar liberar os dispositivos')
      }
    },
    async onSelectedDevice (device) {
      if (!this.deviceInfoPerId[device.id]) {
        const mode = this.mode.selected.id
        const pcFields = [
          'id', 'id_copy', 'device_type', 'fingerprint', 'kind',
          'companies', 'employee', 'name', 'reason',
          'active', 'personal', 'recaptcha'
        ]
        const mobileFields = [
          'id', 'id_copy', 'device_type', 'companies', 'name',
          'check_fake_gps', 'disable_gps', 'check_face', 'check_face_accuracy',
          'insecure_mode', 'last_synced', 'app_version', 'imei', 'last_synced_photos',
          'last_synced_audios', 'last_synced_timelogs', 'last_synced_employee_routine',
          'last_synced_employee_list', 'last_synced_timelogs_download',
          'last_synced_dayjourney', 'last_synced_wrong_password', 'remaining_audios',
          'remaining_photos', 'remaining_timelogs', 'last_device_diagnosis'
        ]
        this.$set(this.deviceInfoPerId, device.id, {...device})
        this.loadingSelectedDeviceInfo = true
        const completeInfo = await this.$API.deviceManage.get({
          search: device.id,
          type: this.mode.selected.id,
          fields: JSON.stringify(mode === 'pc' || mode === 'app-gestor' ? pcFields : mobileFields)
        })
        this.$set(this.deviceInfoPerId, device.id, completeInfo.data.success[0])
        this.loadingSelectedDeviceInfo = false
      }
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    },
    changeMode () {
      this.closeDetailsTable()
      this.$refs.table.resetPagesAndReload()
    },
    updateTableAndCloseDetailsBox () {
      this.closeDetailsTable()
      this.$refs.table.resetPagesAndReload()
    }
  },
  components: { Details }
}
</script>

<style scoped lang="scss">
.devices-wrapper {
  display: grid;
  grid-template-rows: min-content min-content auto;
  grid-template-columns: 1fr;

  h2 {
    text-align: center;
  }

  .filters {
    grid-row: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: column;
    align-items: center;

    .total {
      justify-self: start;
      display: grid;
      grid-template-columns: 200px 300px;
      grid-auto-flow: column;
      grid-gap: 30px;
      align-items: center;
    }
    .buttons {
      justify-self: end;
      display: grid;
      grid-auto-flow: column;
      column-gap: 1px;
      align-items: center;
    }
  }

  .table {
    grid-row: 3;

    .loading-field {
      width: 30%;
      height: 60%;
      background-color: lightgray;
    }

    .active {
      height: 100%;
      display: grid;
      align-items: center;
      justify-items: left;
      padding-left: 20px;
    }
  }
}
</style>
